import React from 'react';

/**
 * Route-level loading state. Originally a local const in routes.jsx as the
 * Suspense fallback for every lazy route; extracted so StatsigRouteSwitch can
 * show the same spinner while it waits for the signed-in identity to reach
 * Statsig. routes.jsx imports StatsigRouteSwitch, so it could not import back.
 */
const RouteLoading = () => (
    <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '200px' }}
        data-testid="routes.route-loading.container"
    >
        <div className="spinner-border text-primary" role="status">
            <span className="sr-only" data-testid="routes.route-loading.loading-text">Loading...</span>
        </div>
    </div>
);

export default RouteLoading;
